import { create } from 'zustand';

type DevicesStore = {
  devicesLoading: boolean;
  setDevicesLoading: (loading: boolean) => void;
  shouldRefetchDevices: boolean;
  refetchDevices: () => void;
  resetRefetchDevices: () => void;
};

export const useDevicesStore = create<DevicesStore>()((set) => ({
  devicesLoading: false,
  setDevicesLoading: (loading: boolean) => set(() => ({ devicesLoading: loading })),
  shouldRefetchDevices: false,
  refetchDevices: () => set(() => ({ shouldRefetchDevices: true })),
  resetRefetchDevices: () => set(() => ({ shouldRefetchDevices: false })),
}));
